module.exports = __webpack_public_path__ + "img/1.1bf585b3.webp";